<!--
    【使い方】
    関数の定義の例
        public async getAPIKey(): Promise<AxiosResponse> {

            // API_KEYの取得
            const res = await HttpRequestUtil.get(
                "/Mobile/GetEMMMapApiKey"
            );

            return res;
        }

        public async getPositionList(isDateRange: boolean, startDate: Date, endDate: Date, isNext: boolean, nextTime: string): Promise<AxiosResponse> {
            // 送信する。
            const res = await HttpRequestUtil.post(
                "Mobille/GetPositionList",
                bodyData
            );

            return res;
        }


    HTMLで定義
        <CommonEMMLocationInformationComponent :agentID="agentID"
                                               :getPositionListFunction="getPositionList"
                                               :getAPIKey="getAPIKey"
                                               @onClickedDispGoogleMap="onClickedDispGoogleMap"/>
-->

<template>
    <div class="d-flex flex-column default-text-font flex-grow-1">

        <!--上部ー-->
        <div class="individual-top">
            <div class="title-belt-table">
                <span style="margin: 0px 8px">端末機</span>
            </div>
            <div class="overflow-auto">
                <table class="table-scv text-nowrap table-striped table-scv-out-border" frame="box" bordercolor="lightgray">
                    <thead class="sticky-top" style="z-index: 990;">
                        <tr>
                            <th v-for="(column, index) in columnData" :key="index">{{column.text}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-for="(column, index) in columnData" :key="index">{{getCellTextAgentInfo(column.columnID)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="separator-individual-top"></div>
        </div>

        <!--本体ー-->
        <div class="d-flex flex-column flex-grow-1">

            <!--本体ヘッダー-->
            <div class="title-belt-table d-flex flex-row" style="height: 56px">
                <!--左側 対象端末ー-->
                <div class="d-flex emm-page-left-header">
                    <span style="margin-left:16px">位置情報の履歴</span>
                    <template v-if="isShowEmmLocationHistoryInfoPanel === true">
                        <template v-if="isEmmWebConsoleEnabled === true">
                            <div class="d-flex align-items-center" style="margin-left: 4px;">
                                <InformationManual :arMessage="[getInfoManualWhenEmmWebConsoleEnabled()]" :dispPlacePriority="['bottom', 'top']"/>
                            </div>
                        </template>
                        <template v-else>
                            <div class="d-flex align-items-center" style="margin-left: 4px;">
                                <InformationManual :arMessage="[getInfoManualWhenEmmWebConsoleDisabled()]" :dispPlacePriority="['bottom', 'top']"/>
                            </div>
                        </template>
                    </template>
                </div>

                <!--右側 位置情報ー-->
                <div class="emm-page-right-header">
                    <div class="box-item-title-lightblue" style="min-width:120px"><span>位置情報取得日時</span></div>
                    <div class="box-item-data" style="min-width:130px">{{createRecordTimeString(selectLocationInfo)}}</div>
                    <div class="box-item-title-lightblue" style="min-width:42px"><span>誤差</span></div>
                    <div class="box-item-data" style="min-width: 50px">{{createAccuracyString(selectLocationInfo)}}</div>
                    <div class="box-item-title-lightblue" style="min-width:68px"><span>取得契機</span></div>
                    <div class="box-item-data d-flex flex-row align-items-center">
                        <template v-if="null != selectLocationInfo">
                            <div class="icon-font-slategray icon-font-size-s" style="margin-right: 4px;">
                                <i v-bind:class="createCollectTypeSrc(selectLocationInfo)"></i>
                            </div>
                            <div>{{createCollectTypeString(selectLocationInfo)}}</div>
                        </template>
                    </div>
                </div>
            </div>

            <!--本体ボディ-->
            <div class="d-flex flex-row flex-grow-1">
                <!--左側 位置情報選択画面ー-->
                <div class="emm-page-left-body d-flex flex-column">
                    <!--ラジオボタン-->
                    <div class="d-flex flex-column" style="margin-bottom: 24px;">
                        <div style="margin-bottom: 8px">
                            <label class="scv-check-label-box">
                                <input type="radio"
                                       name="rdo_listDispMode"
                                       v-model="rdobtn_listDispMode"
                                       @change="onChangeDispMode"
                                       :value="1">
                                <span>指定した日付の情報を表示</span>
                            </label>
                        </div>
                        <div class="d-flex align-items-center" style="margin-bottom: 16px">
                            <div>
                                <Datepicker v-model="selectDate"
                                            locale="ja"
                                            :enableTimePicker="false"
                                            :format="dateFormat"
                                            :yearRange="[1970, 2100]"
                                            :minDate="new Date('1970-01-01')"
                                            :maxDate="new Date('2100-12-31')"
                                            :clearable="false"
                                            autoApply
                                            inputClassName="input-text-scv datepickerInput"
                                            weekStart="0"
                                            class="dateSelected"
                                            style="width:160px; margin-left: 28px"
                                            :disabled="0==rdobtn_listDispMode || 0 == this.allowedDates.length"
                                            :allowedDates="allowedDates"/>
                            </div>
                        </div>
                        <div>
                            <label class="scv-check-label-box">
                                <input type="radio"
                                       name="rdo_listDispMode"
                                       v-model="rdobtn_listDispMode"
                                       @change="onChangeDispMode"
                                       :value="0">
                                <span>すべての情報を表示</span>
                            </label>
                        </div>
                    </div>

                    <!--チェックボックス-->
                    <div class="scv-check-box d-flex align-items-center" style="margin-bottom: 16px">
                        <input type="checkbox"
                               id="chk_dispChangePosOnly"
                               v-model="chkbtn_dispChangePosOnly"
                               @change="onDispChangePosOnly" />
                        <label for="chk_dispChangePosOnly" class="scv-check-label">端末の位置が変化した情報のみ表示</label>
                    </div>

                    <!--リスト-->
                    <ListCtrl ref="locationInformationList"
                              :columns="locationInformationColumns"
                              :selectType="1"
                              :getCellTextFunc="getCellTextLocationInfo"
                              :getCellHTMLFunc="getCellHTMLLocationInfo"
                              @onSelectIndexChanged="onSelectIndexChanged"
                              class="d-flex flex-column flex-grow-1"
                              style="height: 0px; margin-bottom: 16px;">
                    </ListCtrl>

                    <!--ページネーション-->
                    <PaginationArea :totalPageNum="totalPageNum"
                                    :totalItemNum="dispPositions.length"
                                    :startItemNumber="startItemNumber"
                                    :endItemNumber="endItemNumber"
                                    :mode="1"
                                    :selectChangeList="[20,50,100]"
                                    @pageNumberClicked="onPageNumberClick"
                                    @onMaxPageItemNumSelectChange="onMaxPageItemNumSelectChange"
                                    ref="paginationArea"
                                    class="d-flex justify-content-center"/>
                </div>

                <!--右側 Google Map APIー-->
                <div class="d-flex flex-column flex-grow-1">
                    <template v-if="1 == mapMode">
                        <div class="d-flex flex-column flex-grow-1" style="background-color: #F0F5FA">
                            <div class="d-flex justify-content-center align-items-center flex-grow-1">
                                <div class="emm-map-link d-flex flex-row align-items-center"
                                     @click="onGoogleMapClicked">
                                    位置情報をGoogleMapで表示する
                                    <div class="menu-sub-icon icon-font-size-xs" style="margin-left: 4px">
                                        <i class="icon-browser_link"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="d-flex flex-grow-1">
                                <iframe style="border:0;"
                                        class="d-flex flex-grow-1"
                                        loading="lazy"
                                        allowfullscreen
                                        referrerpolicy="no-referrer-when-downgrade"
                                        :src="mapURL">
                                </iframe>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { LoadingUtil } from '@/util/LoadingUtil';
    import { EMMPosition, EMMGetPositionListResponse } from '@/models/Mobile/EMMLocation/EMMPosition';
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';
    import Datepicker from 'vue3-date-time-picker'
    import { ListCtrl } from 'lib-vue-v2/components';
    import PaginationArea from '@/components/PaginationArea.vue';
    import '@/util/Extension/DateExtensions';
    import { AxiosResponse } from 'axios'
    import { MessageUtil } from '@/models/Message/MessageUtil';
    import { AssetsData } from '@/models/Hardware/HardwareDetailData';
    import InformationManual from '@/components/InformationManual.vue';
    import calendar from "@/assets/img/calendar.svg";
    import terminal from "@/assets/img/terminal.svg";
    import terminalMobLost from "@/assets/img/terminal_mob_lost.svg";
    import mob from "@/assets/img/mob.svg";
    import mobMobLost from "@/assets/img/mob_mob_lost.svg";

    @Options({
        components: {
            Datepicker,
            ListCtrl,
            PaginationArea,
            InformationManual,
        },
        props: {
            platform: { Type: String, default: "iOS" },                     // プラットフォーム(オンプレ過去管理機を考慮)
            mapMode: { Type: Number, Default: 0 },                          // 表示モード(0:マップ埋め込み表示, 1:マップURL表示)
            getPositionListFunction: { type: Function, required: true },    // (必須)位置情報の取得関数
            getAPIKey: { type: Function, required: true },                  // (必須)APIキー取得関数
            getCollectedDateFunction: { type: Function, required: true },   // (必須)位置情報の収集したことがある日付の取得関数
            onClickedDispGoogleMap: { type: Function, default: null },      // マップ表示ボタン押下時に呼び出す関数
            columnData: { Type: Array, required: true },                    // 端末機リストのカラム
            assetsData: { Type: Object, required: true },                   // 端末の情報
            isEmmWebConsoleEnabled: { Type: Boolean, required: false, default: false },             // MDM専用Web管理コンソールのライセンスが有効か否か
            isShowEmmLocationHistoryInfoPanel: { Type: Boolean, required: false, default: false },  // 位置情報の履歴の補足マニュアルボタンの表示要否
        },
        watch: {
            dispPositions: {
                handler: function () {
                    /* eslint @typescript-eslint/no-explicit-any: 0 */
                    const refObj: any = this.$refs;
                    refObj.locationInformationList.updateList(this.dispPositions.length);
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            },
            selectDate: {
                handler: function (newDate: Date | null, oldDate: Date | null) {
                    if (null != oldDate) {
                        // 画面表示時(oldDateがnull)は、位置情報の取得処理などは不要（自前で実装している）
                        this.onChangeDispMode();
                    }

                },
            },
        },
        emits: [
            'onClickedDispGoogleMap'
        ],
    })

    export default class CommonEMMLocationInformationComponent extends Vue {

        private readonly locationInformationColumns: Array<SearchColumnData> =  // カラム
            [
                { columnID: 2, dataType: SearchColumnType.icon_s, text: "",                 columnWidth: 40 },
                { columnID: 0, dataType: SearchColumnType.string, text: "位置情報取得日時", columnWidth: 150 },
                { columnID: 1, dataType: SearchColumnType.string, text: "誤差",             columnWidth: 70 },
            ];

        // props
        private mapMode!: number;
        private getPositionListFunction!: any;
        private getAPIKey!: any;
        private onClickedDispGoogleMap!: any;
        private getCollectedDateFunction!: any;
        private isEmmWebConsoleEnabled!: boolean;
        private isShowEmmLocationHistoryInfoPanel!: boolean;

        // 端末機情報
        private assetsData!: AssetsData;
        private lastGetLocationInfoDate = "";
        private platform!: string;

        // 位置情報
        private originalPositions = new Array<EMMPosition>();     // オリジナルの位置情報（降順固定）
        private dispPositions = new Array<EMMPosition>();         // 表示する位置情報(端末の位置が変化した情報のみ表示を考慮した内容)

        // UI
        private rdobtn_listDispMode = 1;
        private selectDate: Date | null = null;
        private chkbtn_dispChangePosOnly = false;
        private selectLocationInfo: EMMPosition | null = null;
        private allowedDates = new Array<Date>();   // 選択が許可された日付

        // ページネーション関連
        private totalPageNum = 1;                       // 総ページ数
        private maxPageItemNum = 100;                   // 1ページ毎の最大表示件数（紛失端末機能が100件だったので合わせている）
        private pageNumber = 1;                         // 現在のページ番号
        private startItemNumber = 0;                    // 開始件数
        private endItemNumber = 0;                      // 終了件数

        // iframeに埋め込むURL
        private mapURL = "";

        // APIKEY
        private apiKey = "";

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            // 日付でソート
            const refObj: any = this.$refs;
            refObj.locationInformationList.setSort(0, false);
        }

        /**
         * @brief	データ取得
         */
        public async getData(): Promise<boolean> {

            // 収集日を取得
            const resultCollectedDate = await this.getCollectedDate();
            if (200 != resultCollectedDate) {
                if (401 != resultCollectedDate) {
                    MessageUtil.MessageBox("位置情報の取得に失敗しました。", null, null, MessageUtil.MB_ICON_ERROR);
                }
                return false;
            }

            // APIキーの取得
            const resultApiKey = await this.getAPIKeyData();
            if (200 != resultApiKey) {
                if (401 != resultApiKey) {
                    MessageUtil.MessageBox("位置情報の取得に失敗しました。", null, null, MessageUtil.MB_ICON_ERROR);
                }
                return false;
            }

            // 位置情報を取得
            if (0 < this.allowedDates.length) {
                // 最新の日付(末尾)で位置情報を取得
                this.selectDate = this.allowedDates[0];

                const resultLocation = await this.getLocationData();
                if (200 != resultLocation) {
                    if (401 != resultLocation) {
                        MessageUtil.MessageBox("位置情報の取得に失敗しました。", null, null, MessageUtil.MB_ICON_ERROR);
                    }
                    return false;
                }
            }

            return true;
        }

        /**
         * @brief	データ取得（位置情報）
         */
        public async getCollectedDate(): Promise<number> {

            LoadingUtil.Start();
            try {
                // データ格納
                const res: AxiosResponse = await this.getCollectedDateFunction();

                if (200 != res.status) {
                    return res.status;
                }
                else if (null == res.data) {
                    return 500;
                }

                this.allowedDates = Object.assign(new Array<Date>(), res.data);
            }
            finally {
                LoadingUtil.Stop();
            }

            // return 200
            return 200;
        }

        /**
         * @brief	データ取得（位置情報）
         */
        public async getLocationData(): Promise<number> {

            if (null == this.selectDate) {
                // 収集サーバーにデータがない端末のため、データは取得せず成功を返す
                return 200;
            }

            LoadingUtil.Start();
            try {
                // Webサーバーに送られると勝手にUTCに変わります
                let startDate = new Date(this.selectDate);
                startDate.setHours(0);
                startDate.setMinutes(0);
                startDate.setSeconds(0);
                startDate.setMilliseconds(0);
                let endDate = new Date(this.selectDate);
                endDate.setHours(23);
                endDate.setMinutes(59);
                endDate.setSeconds(59);
                endDate.setMilliseconds(999);

                // 分割取得
                this.originalPositions.splice(0);
                let getNow = true;
                let isNext = false;
                let nextTime = "";
                while (getNow) {
                    // データ格納
                    const res: AxiosResponse = await this.getPositionListFunction(
                        1 == this.rdobtn_listDispMode,
                        startDate,
                        endDate,
                        isNext,
                        nextTime
                    );

                    if (200 != res.status) {
                        return res.status;
                    }
                    else if (null == res.data) {
                        return 500;
                    }

                    let resData = new EMMGetPositionListResponse();
                    resData = Object.assign(resData, res.data);

                    // 次回情報の更新
                    isNext = resData.isNext;
                    nextTime = resData.nextTime;

                    // 取得出来たら所持しておく
                    this.originalPositions.push(...resData.positions);

                    // 次回がなければ終了
                    if (!isNext) {
                        getNow = false;
                    }
                }
            }
            finally {
                LoadingUtil.Stop();
            }

            // 分割取得が完了したら降順にソートしておく
            this.originalPositions = this.originalPositions.sort((prev, next) => {
                if (next.recordTime < prev.recordTime) {
                    return -1;
                }
                else if (next.recordTime > prev.recordTime) {
                    return 1;
                }
                else {
                    return 0;
                }
            })

            // 使用データ更新
            this.updateUsePositions();
            // 表示ページリセット
            this.resetPageNumber();
            // 表示データ更新
            this.showPagenationList();

            if (0 < this.dispPositions.length) {
                // 最新データを選択しておく（dispPositionsのwatchが呼び出された後に選択状態を変更する必要があるので少し遅らせる）
                window.setTimeout(() => {
                    const refObj: any = this.$refs;
                    refObj.locationInformationList.selectRow(0); // emitsは呼ばれない

                    // Mapを表示するために、選択されたケースと同じシーケンスを呼び出す
                    let arr = new Array<number>();
                    arr.push(0);
                    this.onSelectIndexChanged(arr);
                }, 10);
            }

            // return 200
            return 200;
        }

        /**
         * @brief	データ取得（APIKey）
         */
        public async getAPIKeyData(): Promise<number> {
            LoadingUtil.Start();

            // データ格納
            const res: AxiosResponse = await this.getAPIKey();

            LoadingUtil.Stop();

            if (200 != res.status) {
                return res.status;
            }
            else if (null == res.data) {
                return 500;
            }

            this.apiKey = res.data.apiKey;

            // return 200
            return res.status;
        }

        /**
         * リスト作成処理
         */
        private getCellTextAgentInfo(columnId: number): string {
            switch (columnId) {
                // 端末機No.
                case 0:
                    return this.assetsData.agentID;

                // 端末機名
                case 0x1018:
                    return this.assetsData.agentName;

                // コンピュータ名
                case 0x0002:
                    return this.assetsData.computerName;

                // 部署名
                case 0x2000:
                    return this.assetsData.divisionName;

                // プラットフォーム
                case 0x4002:
                    {
                        return this.platform;
                    }
                // デバイス名
                case 0x51009:
                    return this.assetsData.deviceName;

                // IMEI
                case 0x51000:
                    return this.assetsData.imei;

                // 電話番号
                case 0x50001:
                    return this.assetsData.phoneNumber;

                // システムシリアル
                case 0x0007:
                    return this.assetsData.machineSerial;
            }
            return "";
        }


        /**
         * @brief	リスト作成処理
         */
        private getCellTextLocationInfo(columnId: number, index: number): string {

            if (this.dispPositions.length <= index) {
                return "";
            }

            switch (columnId) {
                // 取得日時
                case 0:
                    return this.createRecordTimeString(this.dispPositions[index]);
                // 誤差
                case 1:
                    return this.createAccuracyString(this.dispPositions[index]);
                // アイコン
                case 2:
                    // getCellHTMLLocationInfo()
                    return "";
            }

            return "";
        }

        /**
         * @brief	リスト作成処理(HTML)
         */
        private getCellHTMLLocationInfo(columnId: number, index: number): string {

            if (this.dispPositions.length <= index) {
                return "";
            }

            switch (columnId) {
                // アイコン
                case 2:
                    {
                        let src = this.createCollectTypeSrc(this.dispPositions[index]);
                        let html = "";
                        html += "<div class=\"icon-font-slategray icon-font-size-s\">"
                        {
                            html += "<i class=\"" + src + "\"></i>";
                        }
                        html += "</div>";

                        return html;
                    }
            }

            return "";
        }

        /**
         * @brief	日付フォーマット(時刻なし)
         */
        public dateFormat(target: Date): string {
            return target.SystemtimeToDateStr();
        }

        /**
         * @brief	端末の位置が変化した情報のみ表示をクリック
         */
        public onDispChangePosOnly(): void {
            // 使用データ更新
            this.updateUsePositions();
            // 表示ページリセット
            this.resetPageNumber();
            // 表示データ更新
            this.showPagenationList();
        }

        /**
         * @brief	選択変更通知
         */
        public onSelectIndexChanged(selectDisplayIndex: Array<number>): void {
            if (selectDisplayIndex.length <= 0) {
                return;
            }

            // 単一選択
            const index = selectDisplayIndex[0];

            // マップ表示
            this.selectLocationInfo = Object.assign(new EMMPosition(), this.dispPositions[index]);
            let location = this.dispPositions[index].latitude + "," + this.dispPositions[index].longitude;

            if (1 == this.mapMode) {
                // マップURL表示
                this.mapURL = "https://maps.google.co.jp/maps?"
                    + "ll=" + location
                    + "&q=" + location
                    + "&z=14";
            }
            else {
                // マップ埋め込み
                this.mapURL = "https://www.google.com/maps/embed/v1/place"
                    + "?key=" + this.apiKey
                    + "&q=" + location
                    + "&center=" + location
                    + "&zoom=14";
            }
        }

        /**
         * @brief	設定変更時
         */
        public async onChangeDispMode(): Promise<void> {
            const resultLocation = await this.getLocationData();
            if (200 != resultLocation) {
                if (401 != resultLocation) {
                    MessageUtil.MessageBox("位置情報の取得に失敗しました。", null, null, MessageUtil.MB_ICON_ERROR);
                }
            }

            // 表示ページリセット
            this.resetPageNumber();
            // 表示データ更新
            this.showPagenationList();
        }

        /**
         * @brief	マップ表示のときに使用
         */
        public onGoogleMapClicked(): void {
            if (this.mapURL.length <= 0) {
                MessageUtil.MessageBox("「位置情報の履歴」から表示する位置情報を選択してください。", null, null, MessageUtil.MB_ICON_WARNING);
                return;
            }

            // 外からブラウザを表示する為、登録している関数を呼び出す
            this.$emit("onClickedDispGoogleMap", this.mapURL);
        }

        /**
         * @brief	ページネーションボタンのクリックイベント
         * @param   [in]    pageNumber    クリック後のページ番号
         */
        public onPageNumberClick(pageNumber: number): void {
            this.pageNumber = pageNumber;

            // 表示データ更新
            this.showPagenationList();
        }

        /**
         * @brief	表示件数の変更イベント
         * @param   [in]    maxNum    1ページの表示件数
         */
        public onMaxPageItemNumSelectChange(maxNum: number): void {
            this.maxPageItemNum = maxNum;

            // 表示データ更新
            this.showPagenationList();
        }

        /**
         * @brief	使用データ更新
         */
        private updateUsePositions(): void {
            // まずは初期化
            this.dispPositions.splice(0);

            if (!this.chkbtn_dispChangePosOnly) {
                this.dispPositions = Object.assign(new Array<EMMPosition>(), this.originalPositions);
                return;
            }

            // 直近の項目と比較して、緯度経度に変更がないものは省く
            let prevLatitude = 0;
            let prevLongitude = 0;
            const place = 10000;

            // 小数第4位まで四捨五入して比較する。
            const count = this.originalPositions.length;
            for (let i = count - 1; 0 <= i; i--) {
                const x = this.originalPositions[i];

                let latitude = Number(x.latitude);
                latitude = Math.round(latitude * place) / place;
                let longitude = Number(x.longitude);
                longitude = Math.round(longitude * place) / place;

                if (prevLatitude == 0 ||
                    prevLatitude != latitude ||
                    prevLongitude != longitude) {
                    this.dispPositions.push(x);
                }

                prevLatitude = latitude;
                prevLongitude = longitude;
            }
        }

        /**
         * @brief	表示データ更新
         */
        private showPagenationList(): void {
            // 総データ数を元に総ページ数を計算する
            this.totalPageNum = Math.ceil(this.dispPositions.length / this.maxPageItemNum);
            if (0 == this.totalPageNum) {
                // リストの表示が0件の場合は、総ページ数1にする
                this.totalPageNum = 1;
            }

            // 開始件数、終了件数を計算する
            this.startItemNumber = 0;
            this.endItemNumber = 0;
            if (0 < this.dispPositions.length) {
                this.startItemNumber = (this.pageNumber * this.maxPageItemNum) - this.maxPageItemNum + 1;
                this.endItemNumber = (this.pageNumber * this.maxPageItemNum);
                if (this.endItemNumber > this.dispPositions.length) {
                    this.endItemNumber = this.dispPositions.length;
                }
            }

            // ListCtrlに表示するインデックスを渡す
            const refObj: any = this.$refs;
            refObj.locationInformationList.setPaginationIndex(this.startItemNumber - 1, this.endItemNumber - 1);
        }

        /**
         * @brief	表示ページリセット
         */
        private resetPageNumber(): void {
            this.pageNumber = 1;
            const refObj: any = this.$refs;
            refObj.paginationArea.resetPageNumber();
        }

        /**
         * @brief	位置情報取得日時 表示用文字列作成
         * @return	文字列
         */
        private createRecordTimeString(positionInfo: EMMPosition): string {
            if (null == positionInfo) {
                return "";
            }

            let date = new Date(positionInfo.recordTime);
            date.setHours(date.getHours() + 9);
            return date.SystemtimeToStr7();
        }

        /**
         * @brief	位置情報の誤差 表示用文字列作成
         * @return	文字列
         */
        private createAccuracyString(positionInfo: EMMPosition): string {
            if (null == positionInfo || "" == positionInfo.accuracy) {
                return "";
            }

            const index = positionInfo.accuracy.indexOf(".");
            if (-1 == index) {
                return positionInfo.accuracy + "m";
            }

            return positionInfo.accuracy.substring(0, index) + "m";
        }

        /**
         * @brief	位置情報の誤差 表示用文字列作成
         * @return	文字列
         */
        private createCollectTypeString(positionInfo: EMMPosition): string {
            if (null == positionInfo) {
                return "";
            }

            switch (positionInfo.collecttype) {
                case 0:
                    return "スケジュール";
                case 1:
                    return "管理コンソール";
                case 2:
                    return "管理コンソール（紛失モード）";
                case 3:
                    return "モバイルデバイス応急対策ツール";
                case 4:
                    return "モバイルデバイス応急対策ツール（紛失モード）";
            }

            return "";
        }

        /**
         * @brief	スケジュール又は管理機のアイコンファイル
         * @return	文字列
         */
        private createCollectTypeSrc(positionInfo: EMMPosition): string {
            if (null == positionInfo) {
                return "";
            }

            switch (positionInfo.collecttype) {
                // スケジュール
                case 0:
                    return "icon-calendar";
                // 管理機
                case 1:
                    return "icon-pc_individual";
                // 管理機（紛失モード）
                case 2:
                    return "icon-terminal_mob_lost";
                //モバイルデバイス応急対策ツール
                case 3:
                    return "icon-mob";
                //モバイルデバイス応急対策ツール（紛失モード）
                case 4:
                    return "icon-mob_mob_lost";
            }

            return "";
        }

        /**
         * @brief   補足マニュアルの内容を作成(MDM専用Web管理コンソールライセンスが有効)
         * @returns 補足マニュアルの内容
         */
        private getInfoManualWhenEmmWebConsoleEnabled(): string {
            let strRet = "";
            strRet += '<div>';
            strRet += '位置情報の取得契機を以下のアイコンで表示しています。<br />';
            strRet += '　・' + '<img src="' + calendar            + '" height="20" width="20">' + ' スケジュール<br />';
            strRet += '　・' + '<img src="' + terminal            + '" height="20" width="20">' + ' 管理コンソール<br />';
            strRet += '　・' + '<img src="' + terminalMobLost   + '" height="20" width="20">' + ' 管理コンソール（紛失モード）<br />';
            strRet += '　・' + '<img src="' + mob                 + '" height="20" width="20">' + ' モバイルデバイス応急対策ツール<br />';
            strRet += '　・' + '<img src="' + mobMobLost        + '" height="20" width="20">' + ' モバイルデバイス応急対策ツール（紛失モード）<br />';
            strRet += '</div>';
            return strRet;
        }

        /**
         * @brief   補足マニュアルの内容を作成(MDM専用Web管理コンソールライセンスが無効)
         * @returns 補足マニュアルの内容
         */
        private getInfoManualWhenEmmWebConsoleDisabled(): string {
            let strRet = "";
            strRet += '<div>';
            strRet += '位置情報の取得契機を以下のアイコンで表示しています。<br />';
            strRet += '　・' + '<img src="' + calendar            + '" height="20" width="20">' + ' スケジュール<br />';
            strRet += '　・' + '<img src="' + terminal            + '" height="20" width="20">' + ' 管理コンソール<br />';
            strRet += '　・' + '<img src="' + terminalMobLost   + '" height="20" width="20">' + ' 管理コンソール（紛失モード）<br />';
            strRet += '</div>';
            return strRet;
        }
    }
</script>

<style>
    @import "../../../../../wwwroot/css/table.css";
</style>

<style scoped>
	
    /* 高さだけ指定 残りはapp.css */
    .box-item-title-lightblue {
        height: 40px;
        margin-right: 8px;
    }

    .emm-page-left-header {
        min-width: 320px;
    }

    .emm-page-right-header {
        display: flex !important;
        align-items: center !important;
        font-weight: 400;
    }

    .emm-page-right-header .box-item-title-lightblue span, .emm-page-right-header .box-item-data
    {
        font-size: 13px !important;
        line-height: 1.25 !important;
    }

    .emm-page-left-body {
        border-right: 1px solid #E1E6F5;
        min-width: 320px;
        padding: 16px;
    }

    .emm-map-link {
        font-size: 15px;
        color: #196FC2;
    }
    .emm-map-link:hover {
        opacity: 0.4;
        cursor: pointer;
    }

</style>
